<template>
  <div class="nr-hexagons-row">
    <div
      v-for="standard in standards"
      :key="standard.id"
      class="standard-selection-plate"
      :class="standard.active == 0 || !selected_order_of_service ? 'disabled' : ''"
      @click="standard.active == 1 && selected_order_of_service ? selectStandard(standard.id) : ''"
      :title="!selected_order_of_service ? 'Selecione uma ordem de serviço para continuar' : ''"
    >
      <div>
        <div class="d-flex flex-column w-100 h-100 align-items-center justify-content-center">
          <span>NR</span>
          <span>{{ standard.name.replace(/\D/g, '') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from '@vue/runtime-core'
  import { mapActions, useStore } from 'vuex'
  import { useRouter } from 'vue-router'

  export default {
    setup() {
      const store = useStore()
      const router = useRouter()
      const selected_company = computed(() => store.getters.selected_company)
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)
      const authenticated_user = store.getters['authenticated_user']

      return {
        selected_company,
        selected_order_of_service,
        authenticated_user,
        router
      }
    },
    data() {
      return {
        standards: [],
        loading: true,
      }
    },
    mounted() {
      if (!this.authenticated_user.email_verified_at) {
        this.router.push('/change-password/' + this.authenticated_user.id)
      }
      this.list()
    },
    methods: {
      ...mapActions({
        selectStandardAction: 'selectStandard',
      }),

      list() {
        var app = this
        app.axios
          .get('/api/standards/all')
          .then(function (response) {
            app.standards = response.data.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            app.loading = false
          })
      },

      async selectStandard(standard_id) {
        var app = this
        if (this.selected_order_of_service) {
          await app.selectStandardAction(standard_id)
          if (standard_id !== 4) app.$router.replace({ path: '/machines' })
          else app.$router.replace({ path: '/confined-spaces' })
        }
      },
    },
  }
</script>
